import { render, staticRenderFns } from "./AdminConsole.vue?vue&type=template&id=f25fc428&scoped=true"
import script from "./AdminConsole.vue?vue&type=script&lang=js"
export * from "./AdminConsole.vue?vue&type=script&lang=js"
import style0 from "./AdminConsole.vue?vue&type=style&index=0&id=f25fc428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25fc428",
  null
  
)

export default component.exports